"use client"

import clsx from "clsx";
import { useState, useCallback } from "react";
import RecordCard from "@/components/card/record-card/record-card";
import RecordCtaCard from "@/components/card/record-cta-card/record-cta-card";

export default function RecordsGalleryGroupMobile({
  recordCategoryType = "curated",
  isFeaturedRecords = false,
  cards,
  batchSize = 15,
}) {
  const [batchesInView, setBatchesInView] = useState(new Set());

  const onBatchEnter = useCallback((batchIndex) => {
    setBatchesInView(prev => {
      if (prev.has(batchIndex)) return prev;
      const next = new Set(prev);
      next.add(batchIndex);
      return next;
    });
  }, []);

  const cardInertia = 0;
  return (
    <div
      className={clsx(
        "flex flex-col gap-y-20 md:gap-y-14 xl:gap-y-[6.625rem] relative will-change-transform col-span-3"
      )}
    >
      {cards.map((card, index) => {
        const batchIndex = Math.floor(index / batchSize);
        const cardIndexWithinBatch = index % batchSize;
        const isFirstInBatch = cardIndexWithinBatch === 0;
        const isParentInView = batchesInView.has(batchIndex);

        if (card.isCta) {
          return (
            <RecordCtaCard
              recordCategoryType={recordCategoryType}
              className="px-[10%]"
              intertia={cardInertia}
              isParentInView={isParentInView}
              index={cardIndexWithinBatch}
              key={index + '_mobile'}
              isFirstInBatch={isFirstInBatch}
              batchIndex={batchIndex}
              onBatchEnter={onBatchEnter}
            />
          );
        }

        return (
          <RecordCard
            recordCategoryType={recordCategoryType}
            isFeaturedRecords={isFeaturedRecords}
            intertia={cardInertia}
            isParentInView={isParentInView}
            data={card}
            index={cardIndexWithinBatch}
            key={index + '_mobile'}
            isFirstInBatch={isFirstInBatch}
            batchIndex={batchIndex}
            onBatchEnter={onBatchEnter}
          />
        );
      })}
    </div>
  );
}
